<template>
  <div class="train-course" id="train-course">
    <div class="div-top" v-if="details.campStatus !== '3'">
      <div class="div-bg" v-if="details && details.cover" :style="{ backgroundImage: `url(${details.cover.url})` }"></div>
      <div class="top-con">
        <div class="con-title" @click="handleJump">
          <span class="txt">{{ details && details.title }}</span>
          <img src="@/assets/images/training/img(4).png" class="icon-more" alt=""/>
        </div>
        <template v-if="isStart">
          <div class="cons-times">{{ details && details.startTimeTxt }}开营</div>
          <div class="cons-countdown">
            <img src="@/assets/images/training/img(3).png" class="icon-count" alt=""/>
            <span class="label-txt">倒计时</span>
            <span class="val-txt">{{ details && details.cutTime }}</span>
          </div>
        </template>
        <div class="flex-nav" v-else>
          <div class="nav-cons">
            <div class="num-txt">
              {{ recordDetails.addDay > 0 ? recordDetails.addDay : 0 }}
            </div>
            <div class="con-txt">累计学习(天数)</div>
          </div>
          <div class="nav-cons">
            <div class="num-txt">
              {{ recordDetails.addDuration > 0 ? Math.ceil(recordDetails.addDuration / 60) : 0 }}
            </div>
            <div class="con-txt">累计时长(分钟)</div>
          </div>
          <div class="nav-cons">
            <div class="num-txt">
              {{ recordDetails.learningProgress > 0 ? recordDetails.learningProgress : 0 }}%
            </div>
            <div class="con-txt">学习进度</div>
          </div>
        </div>
      </div>
    </div>
    <div class="div-section">
      <template v-if="details.campStatus !== '3'">
        <div class="sec-top" v-if="isStart">
          <img src="@/assets/images/training/img(2).png" class="icon-sec icon-sec-left" alt=""/>
          <span class="sec-top-txt">课程安排</span>
          <img src="@/assets/images/training/img(1).png" class="icon-sec icon-sec-right" alt=""/>
        </div>
        <template v-else>
          <div class="sec-flex-nav">
            <div class="sec-txt" @click="handleClickFlex('1')" :class="flexActive === '1' ? 'cur' : ''">
              全部任务
            </div>
            <div class="sec-txt" @click="handleClickFlex('2')" :class="flexActive === '2' ? 'cur' : ''">
              学习榜单
            </div>
          </div>
          <div class="sec-times" v-if="flexActive === '1'">
            已开营第<span class="col">{{ details.dayDifference }}</span>天
          </div>
        </template>
      </template>

      <div class="sec-block" v-if="flexActive === '1'">
        <div class="sec-block-top" v-for="(item, index) in course" :key="index">
          <div class="top-block">
            Day{{ item.whichDay }}
            <div class="test-btn" @click="handleGetQuestion(item)"
                 v-if="item.questionButton && !isStart && item.whichDay <= details.dayDifference">
              测试题
            </div>
          </div>
          <div class="sec-block-con" v-for="(itm, idx) in item.studyContent" :key="itm.baseId + idx">
            <div class="con-tag one" v-if="`${itm.learningStatus}` === '1'">已完成</div>
            <div class="con-tag two" v-if="`${itm.learningStatus}` === '2'">进行中</div>
            <div class="con-tag three" v-if="`${itm.learningStatus}` === '3'">待开始</div>
            {{ itm.docuCourseCase ? itm.docuCourseCase.title : '' }}
            <div class="con-btm" v-if="!isStart">
              <!-- 1文献2课程3病例 type -->
              <div class="btm-txt flex-div">
                <span class="txt-left">
                  {{ itm.type === 1 ? "文献" : itm.type === 3 ? "病例" : "课程学习" }}
                </span>
                <div class="item-unlock" v-if="`${item.isUnlock}` === '1' && !item.myUnlock">
                  <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt="">
                  <span class="txt">{{ item.unlockCost }}积分解锁</span>
                </div>
              </div>
              <div class="btm-btn" @click="handleDialogUnlock(itm)" v-if="item.whichDay <= details.dayDifference">
                学习
              </div>
              <div class="btm-txt" v-else>待开课</div>
            </div>
          </div>
        </div>
      </div>
      <div class="sec-ranks" v-else-if="flexActive === '2'">
        <div class="ranks-top">
          <div class="top-left">TOP</div>
          <div class="top-right">截至昨日总时长</div>
        </div>
        <div class="ranks-list" v-if="recordList && recordList.length > 0">
          <div class="ranks-item" v-for="(item, index) in recordList" :key="index">
            <div class="item-tag tag-one" v-if="index + 1 === 1">
              {{ index + 1 }}
            </div>
            <div class="item-tag tag-two" v-if="index + 1 === 2">
              {{ index + 1 }}
            </div>
            <div class="item-tag tag-three" v-if="index + 1 === 3">
              {{ index + 1 }}
            </div>
            <div class="item-tag tag-four" v-if="index + 1 > 3">
              {{ index + 1 }}
            </div>
            <img :src="item.userInfo.headPicUrl" class="item-cover" alt=""/>
            <div class="item-cons">
              <div class="item-cons-top">
                <div class="top-txt">{{ item.userInfo.nickName }}</div>
                <template v-for="(itm, idx) in item.userMedalDTOS">
                  <img :key="idx" v-if="`${itm}` === '1'" src="@/assets/images/training/img(13).png" class="top-tag"
                       alt=""/>
                  <img :key="idx" v-if="`${itm}` === '2'" src="@/assets/images/training/img(16).png" class="top-tag"
                       alt=""/>
                  <img :key="idx" v-if="`${itm}` === '3'" src="@/assets/images/training/img(12).png" class="top-tag"
                       alt=""/>
                  <img :key="idx" v-if="`${itm}` === '4'" src="@/assets/images/training/img(15).png" class="top-tag"
                       alt=""/>
                  <img :key="idx" v-if="`${itm}` === '5'" src="@/assets/images/training/img(14).png" class="top-tag"
                       alt=""/>
                </template>
                <span class="top-times">{{
                    item.playDurationTotal > 0 ? Math.ceil(item.playDurationTotal / 60) : 0
                  }}分钟</span>
              </div>
              <div class="hos-txts">{{ item.userInfo.hospitalName }}</div>
            </div>
          </div>
        </div>
        <div class="empty-block" v-else-if="isNone">
          <img src="@/assets/images/zone/img18.png" class="empty-img" alt=""/>
          <div class="empty-txt">学习榜单暂无内容</div>
        </div>
      </div>
      <div class="live-block"
           v-if="flexActive === '1' && details.campStatus !== '3' && liveBlock && Object.keys(liveBlock).length > 0"
           @click="handleClickLive" v-track="{ functionName: '训练营-轻轻松松训练营详情-直播' }">
        <img
          :src="`${liveBlock.meetingType}` === '2' ? liveBlock.zoomCoverPics ? liveBlock.zoomCoverPics.url : '' : liveBlock.iliveCoverLink"
          class="live-cover" alt=""/>
        <div class="live-con">
          <div class="tag">直播</div>
          <div class="con-btm">
            <div class="btm1">{{ liveBlock.meetingName }}</div>
            <div class="btm2">直播时间: {{ liveBlock.startTime }}</div>
          </div>
          <div class="btm-btn">
            {{ liveBlock.meetingStatus === 2 ? "待开始" : liveBlock.meetingStatus === 1 ? "进行中" : "已结束" }}
          </div>
        </div>
      </div>
    </div>
    <dialog-unlock ref="dialogUnlock" @unlockSuccess="handleStudy" :dataProps="dataProps"></dialog-unlock>
  </div>
</template>
<script>
import {
  getTrainingDetails,
  getStudyRecord,
  getNewMeeting,
  getCampQuestionList,
  getQuestionList
} from '@/api/training'
import {setSha, traceClickURL} from '../../utils/util'
import dialogUnlock from '@/components/dialogUnlock.vue'
import {getShareInfo} from '@/utils/wxShare'
import withRouteTracking from '@/utils/withRouteTracking'
import {getQuestionEndList} from '../../api/training'
import {isScorm} from '../../api/scorm'

const UserProfile = {
  components: {
    dialogUnlock
  },
  data() {
    return {
      details: {},
      recordList: [],
      recordDetails: {},
      flexActive: '1',
      startDay: 1,
      course: [],
      courseDayArr: [],
      liveBlock: {},
      dataDetails: {},
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      },
      isNone: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    isStart() {
      return this.details.startTime > new Date().getTime()
    }
  },
  async mounted() {
    await this.handleGetTrainingDetails()
    await this.handleGetQuestionList()
    await this.handleGetStudyRecord()
    await this.handleGetNewMeeting()
  },
  methods: {
    async handleGetQuestionList() {
      if (this.details.campStatus === '3') {
        try {
          const res = await getQuestionEndList({campId: this.$route.query.campId})
          this.course = res.data
        } catch (e) {
          console.error(e)
          throw e
        }
      } else {
        try {
          const res = await getQuestionList({campId: this.$route.query.campId})
          this.course = res.data
        } catch (e) {
          console.error(e)
          throw e
        }
      }
    },
    async handleGetTrainingDetails() {
      try {
        const res = await getTrainingDetails({
          campId: this.$route.query.campId
        })
        this.details = res.data
        this.details.startTimeTxt = this.$moment(this.details.startTime * 1).format('YYYY年MM月DD日')
        const day = Math.floor(this.details.timeDifference / 1000 / 60 / 60 / 24)
        const hours = Math.floor((this.details.timeDifference - day * 1000 * 60 * 60 * 24) / 1000 / 60 / 60)
        const minute = Math.floor((this.details.timeDifference - day * 1000 * 60 * 60 * 24 - hours * 1000 * 60 * 60) / 1000 / 60)
        const seconds = Math.floor((this.details.timeDifference - day * 1000 * 60 * 60 * 24 - hours * 1000 * 60 * 60 - minute * 1000 * 60) / 1000)
        this.details.cutTime = day > 0 ? `${day}天${hours}小时` : hours > 0 ? `${hours}小时${minute}分钟` : `${minute}分钟${seconds}秒钟`
        this.startDay = Math.floor((new Date().getTime() - this.details.startTime * 1) / 1000 / 60 / 60 / 24)

        window.sessionStorage.setItem('mainId', this.details.id)
        window.sessionStorage.setItem('serviceId', this.details.id)
        let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : ''
        window.sessionStorage.setItem('entrance', entrance)
        window.sessionStorage.setItem('traceTitle', this.details.title)
        let desc = '学习电生理，训练营等你！'
        let images = this.details.cover ? this.details.cover.url : `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`
        getShareInfo({
          title: this.details.title,
          titleTimeLine: this.details.title,
          desc,
          link: window.location.href, // modifyURLParam(window.location.href, 'entrance', '20'),
          linkTimeLine: window.location.href, // modifyURLParam(window.location.href, 'entrance', '21'),
          images,
        })
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async handleGetStudyRecord() {
      try {
        const res = await getStudyRecord({
          userId: this.userInfo.id,
          campId: this.$route.query.campId
        })
        this.recordDetails = res.data
        this.recordList = res.data.campStudyListDTOList
        this.isNone = !((this.recordList && this.recordList.length <= 0))
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async handleGetNewMeeting() {
      try {
        const res = await getNewMeeting({
          userId: this.userInfo.id,
          campId: this.$route.query.campId
        })
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.liveBlock = res.data.list[0]
          this.liveBlock.startTime = this.$moment(res.data.list[0].startTime * 1).format('YYYY.MM.DD HH:mm')
          if (this.$route.query.pageType === 'livePage') {
            this.$nextTick(() => {
              this.scrollToBottom()
            })
          }
        }
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    scrollToBottom() {
      window.scrollTo({
        top: 10000,
        behavior: 'smooth' // 平滑滚动
      })
    },
    handleClickFlex(index) {
      this.flexActive = index
    },
    handleJump() {
      this.$router.push({
        path: 'trainingDetail',
        query: {
          campId: this.$route.query.campId
        }
      })
    },
    handleDialogUnlock(item) {
      this.dataDetails = item
      if (`${item.isUnlock}` === '1' && !item.myUnlock) {
        this.dataProps.baseId = item.baseId
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleStudy()
    },
    async handleStudy() {
      window.sessionStorage.setItem('entrance', '54')
      let item = this.dataDetails
      let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      let trackParams = `&entrance=54&businessChannel=54&campId=${this.$route.query.campId}`
      if (item.type === 1) {
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.baseId,
            campId: this.$route.query.campId,
            businessId: this.$route.query.campId,
            entrance: '54',
            channel: '54'
          }
        })
        // setTimeout(() => { traceClickURL() })
        // window.location.href = `${process.env.iepUrl}/mobile/home/article-detail?index=0&id=${item.baseId}${openid}${iepTxt}${trackParams}&campId=${this.$route.query.campId}`
      } else if (item.type === 3) {
        setTimeout(() => {
          traceClickURL()
        })
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.baseId}${openidBindli}${trackParams}`
      } else if (item.type === 2) {
        const query = {
          courseId: item.baseId,
          campId: this.$route.query.campId,
          businessId: this.$route.query.campId,
          entrance: '54',
          channel: '54'
        }
        const isscorm = await isScorm(item.baseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      }
    },
    handleClickLive() {
      if (this.details.timeDifference > 0) return
      setTimeout(() => {
        traceClickURL()
      })
      if (`${this.liveBlock.meetingType}` === '1') {
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/liveDetails?liveId=${this.liveBlock.meetingLink}&businessId=${this.$route.query.campId}&entrance=54&channel=54`)
        this.$router.push({
          path: '/liveDetails',
          query: {
            liveId: this.liveBlock.meetingLink,
            businessId: this.$route.query.campId,
            entrance: '54',
            channel: '54',
          },
        })
      } else {
        window.open(this.liveBlock.meetingLink)
      }
    },

    async handleGetQuestion(item) {
      const params = {
        campId: this.$route.query.campId,
        whichDay: item.whichDay
      }
      this.allQues = await getCampQuestionList(params)
      if (this.allQues.data.length <= 0) {
        this.$toast('暂无测试题')
        return
      }
      this.$router.push({
        path: '/train_ques',
        query: {
          campId: this.$route.query.campId,
          whichDay: item.whichDay
        }
      })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.train-course {
  min-height: 100vh;
  padding-bottom: 40px;
  box-sizing: border-box;

  .div-top {
    position: relative;
    height: 190px;
    width: 100%;

    .div-bg {
      background-image: url("../../assets/images/training/div-top-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
      transform: translateZ(0);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    .top-con {
      width: 343px;
      height: 127px;
      background: #fff;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 40px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .con-title {
        display: flex;
        align-items: center;
        height: 24px;
        font-size: 16px;
        color: #000;
        font-weight: 500;

        .txt {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          max-width: 200px;
        }

        .icon-more {
          width: 12px;
          height: 12px;
          display: block;
          margin-left: 2px;
          margin-top: 2px;
        }
      }

      .flex-nav {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 22px;
        box-sizing: border-box;
        margin-top: 8px;

        .nav-cons {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .num-txt {
            font-size: 16px;
            color: #EB1700;
            font-weight: 500;
            line-height: 24px;
            font-family: Source Han Sans CN, Source Han Sans CN;
          }

          .con-txt {
            font-size: 12px;
            color: #7a8494;
            font-family: Source Han Sans CN, Source Han Sans CN;
          }
        }
      }

      .cons-times {
        line-height: 24px;
        font-size: 12px;
        color: #7a8494;
      }

      .cons-countdown {
        display: flex;
        align-items: center;
        height: 24px;

        .icon-count {
          width: 14px;
          height: 14px;
          display: block;
          margin-top: 2px;
        }

        .label-txt {
          font-size: 14px;
          color: #000000;
          margin-right: 5px;
          margin-left: 2px;
        }

        .val-txt {
          font-size: 14px;
          color: #EB1700;
          font-weight: 500;
        }
      }
    }
  }

  .div-section {
    .sec-top {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 24px;
      padding-bottom: 17px;
      box-sizing: border-box;

      .icon-sec {
        width: 121px;
        height: 24px;
      }

      .sec-top-txt {
        width: 70px;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #000000;
      }
    }

    .sec-flex-nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 95px;
      box-sizing: border-box;
      height: 24px;
      margin-top: 14px;
      margin-bottom: 20px;

      .sec-txt {
        font-size: 14px;
        color: #000000;
        font-weight: 400;

        &.cur {
          position: relative;
          color: #EB1700;
          font-weight: 500;

          &::after {
            position: absolute;
            width: 23px;
            height: 9px;
            bottom: -8px;
            left: 50%;
            transform: translateX(-50%);
            background-image: url("../../assets/images/training/img(6).png");
            background-size: 100%;
            background-repeat: no-repeat;
            content: "";
          }
        }
      }
    }

    .sec-times {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #F9F8F7;
      border-radius: 4px;
      font-size: 14px;
      color: #000000;
      height: 44px;
      margin: 0 20px;
      margin-bottom: 6px;

      .col {
        color: #EB1700;
      }
    }

    .sec-block {
      margin-left: 26px;
      margin-right: 20px;
      padding-left: 10px;
      box-sizing: border-box;
      position: relative;

      &::before {
        position: absolute;
        width: 1px;
        height: calc(100% - 20px);
        border-left: 1px dashed #EB1700;
        top: 10px;
        left: 0;
        content: "";
      }

      .sec-block-top {
        margin-bottom: 14px;

        .top-block {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 24px;
          position: relative;
          font-size: 14px;
          color: #EB1700;
          margin-bottom: 6px;

          &::before {
            position: absolute;
            width: 13px;
            height: 13px;
            background-image: url("../../assets/images/training/circle.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            top: 50%;
            transform: translateY(-50%);
            left: -16px;
            content: "";
          }

          .test-btn {
            width: 66px;
            height: 24px;
            border-radius: 100px;
            border: 1px solid #EB1700;
            text-align: center;
            line-height: 24px;
            font-size: 14px;
            color: #EB1700;
            box-sizing: border-box;
          }
        }

        .sec-block-con {
          padding-top: 12px;
          padding-bottom: 14px;
          padding-right: 12px;
          box-sizing: border-box;
          background-color: #F9F8F7;
          border-radius: 4px;
          font-size: 14px;
          color: #000000;
          margin-bottom: 8px;
          position: relative;
          padding-left: 30px;
          overflow: hidden;
          min-height: 68px;

          .con-tag {
            position: absolute;
            left: 0;
            top: 0;
            width: 21px;
            height: 100%;
            font-size: 14px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;

            &.one {
              color: #53CE76;
              background: rgba(83, 206, 118, 0.1);
            }

            &.two {
              background: rgba(235, 23, 0, 0.1);
              color: #EB1700;
            }

            &.three {
              background: rgba(255, 91, 12, 0.1);
              color: #FF6017;
            }
          }

          .con-btm {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 24px;
            margin-top: 5px;

            .btm-txt {
              font-size: 12px;
              color: #7a8494;

              &.flex-div {
                display: flex;
                justify-content: space-between;
                flex: 1;

                .item-unlock {
                  display: flex;
                  align-items: center;
                  height: 20px;
                  margin-top: 2px;
                  padding: 0 8px;
                  box-sizing: border-box;

                  .icon-unlock {
                    width: 10px;
                    margin-right: 4px;
                    display: block;
                  }

                  .txt {
                    color: #EB1700;
                    font-size: 12px;
                  }
                }
              }
            }

            .btm-btn {
              background: #EB1700;
              box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
              border-radius: 100px;
              text-align: center;
              height: 24px;
              width: 60px;
              color: #fff;
              font-size: 14px;
              line-height: 24px;
            }
          }
        }
      }
    }

    .sec-ranks {
      padding-left: 26px;
      padding-right: 16px;
      box-sizing: border-box;

      .ranks-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #000000;
        height: 24px;
        margin-bottom: 16px;

        .top-left {
          font-size: 16px;
          font-weight: 500;
        }

        .top-right {
          font-size: 12px;
        }
      }
    }

    .ranks-item {
      margin-bottom: 32px;
      display: flex;
      align-items: center;
      position: relative;
      height: 42px;

      .item-tag {
        width: 18px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        position: absolute;
        top: 0;
        left: 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        font-size: 12px;
        color: #000;

        &.tag-one {
          background-image: url("../../assets/images/training/img(8).png");
        }

        &.tag-two {
          background-image: url("../../assets/images/training/img(9).png");
        }

        &.tag-three {
          background-image: url("../../assets/images/training/img(10).png");
        }

        &.tag-four {
          background-image: url("../../assets/images/training/img(11).png");
        }
      }

      .item-cover {
        width: 42px;
        height: 42px;
        display: block;
        margin-right: 6px;
        border-radius: 50%;
      }

      .item-cons {
        flex: 1;

        .item-cons-top {
          display: flex;
          align-items: center;
          position: relative;

          .top-txt {
            line-height: 20px;
            font-size: 14px;
            color: #000000;
            margin-right: 8px;
          }

          .top-tag {
            width: 23px;
            display: block;
            margin-left: 3px;
          }

          .top-times {
            position: absolute;
            right: 0;
            top: 0;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            color: #EB1700;
          }
        }

        .hos-txts {
          font-size: 12px;
          color: #7a8494;
          margin-top: 4px;
          width: 260px;
        }
      }
    }
  }
}

.live-block {
  width: 320px;
  height: 98px;
  margin-left: 50%;
  transform: translateX(-50%);
  position: relative;
  border-radius: 12px;
  overflow: hidden;

  .live-cover {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .live-con {
    position: relative;
    width: 100%;
    height: 100%;

    .tag {
      left: 6px;
      top: 7px;
      position: absolute;
      width: 34px;
      height: 16px;
      border-radius: 4px;
      background: #EB1700;
      box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
      color: #fff;
      font-size: 11px;
      line-height: 16px;
      text-align: center;
    }

    .con-btm {
      position: absolute;
      left: 0px;
      background: linear-gradient(360deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(102, 102, 102, 0) 100%);
      bottom: 0;
      height: 72px;
      width: 100%;
      padding-left: 7px;
      padding-top: 24px;
      box-sizing: border-box;

      .btm1 {
        font-size: 13px;
        color: #fff;
        font-weight: 600;
        line-height: 20px;
        white-space: nowrap;
        width: 240px;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .btm2 {
        font-size: 11px;
        color: #fff;
      }
    }

    .btm-btn {
      position: absolute;
      width: 64px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      border-radius: 100px;
      background-color: #f6f8f5;
      right: 6px;
      bottom: 18px;
      color: rgba(0, 0, 0, 0.41);
      font-weight: bold;
      font-size: 14px;
    }
  }
}

.empty-block {
  padding-top: 40px;
  box-sizing: border-box;

  .empty-img {
    width: 185px;
    display: block;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
  }

  .empty-txt {
    text-align: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/training/trainCourse.vue